import { Paper } from '@material-ui/core';
import React from 'react';

const PaperSheet = props => <Paper {...props} />;

export default PaperSheet;
